import ListAltIcon from "@mui/icons-material/ListAlt";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

const LiteVersionNoContent = ({
  text,
  stops,
}: {
  text: string;
  stops?: boolean;
}) => {
  return (
    <div className="p-12 flex items-center gap-6 rounded bg-gray-100">
      <div
        style={{
          background: "var(--primary-100)",
          width: 70,
          height: 70,
          borderRadius: 50,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            background: "#a4bde0",
            width: 45,
            height: 45,
            borderRadius: 50,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {stops ? (
            <LocationOnOutlinedIcon style={{ color: "var(--primary-600)" }} />
          ) : (
            <ListAltIcon style={{ color: "var(--primary-600)" }} />
          )}
        </div>
      </div>
      <div>{text}</div>
    </div>
  );
};

export default LiteVersionNoContent;
